<template>
  <div>
    <Breadcrumb :title="'FMV Statement'"></Breadcrumb>
    <div>
      <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    </div>
    <div class="btnDiv">
      <BaseToolBar :config="ToolbarConfig" @buttonClicked="toolbarOnClick"></BaseToolBar>
    </div>
    <div>
      <BaseGrid
        :mode="'editform'"
        :config="GridConfig"
        @StatementDownload="statementDownload"
        :data="FMVStatementReportInfoData"
      ></BaseGrid>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import BaseModelFMVStatementReport from "@/models/BaseModelFMVStatementReport.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import { mapGetters } from "vuex";
import { FMVSEntryConfig, ToolbarConfig } from "./FMVSEntryPageConfig.js";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import toolbarUtility from "@/services/toolbarUtility.js";

export default {
  name: "FMVSEntry",
  components: {
    Breadcrumb,
    BaseGrid,
    BaseToolBar,
    BaseSearchBar
  },
  mixins: [funcUtil, toolbarUtility, apiUtil],
  computed: {
    ...mapGetters("getModule", ["withFilter", "getLocalInputControls"])
  },
  mounted() {
    const self = this;
    console.log(self.grid);
    //changes for Toolbar
    self._loadGridSettings("FMVSEntryGrid");
    $("#dropdownPeriodFMVStatement").bind(
      "change",
      self.PeriodChangedEventHandler
    );

    //get the data from FMVStatementReportValuation and FMVStatementReportValuation table. Combine to form the FMVStatementReportValuation Info Grid
    self.getCombinedFMVStatementReportData();
    self.getInputControls();

    //bind databound event to grid
    const grid = $("#FMVSEntryGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdateFMVStatementReportMasterData);
    // grid.dataSource.fetch();
  },
  data: function() {
    return {
      GridConfig: FMVSEntryConfig,
      ToolbarConfig: ToolbarConfig,
      BaseModelFMVStatementReport: BaseModelFMVStatementReport,
      BaseModelInputControl: BaseModelInputControl,
      search: {
        SearchData: ""
      },
      FMVSEntryJSON: {},
      dropdowns: {
        TaxPeriod: { model: "", dataSource: [] }
      },
      FMVStatementReportData: [],
      FMVStatementReportInfoData: []
    };
  },
  methods: {
    getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(
        self.BaseModelInputControl.list
      );
      // self._getInputControls().then(response => {
      console.log(response);
      // Object.keys(self.dropdowns).forEach(key => {
      //   self.dropdowns[key].dataSource = response[key];
      //   // self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
      // });
      let dpTaxPeriodData = [];
      if (response["TaxPeriod"].length) {
        response["TaxPeriod"].forEach(element => {
          // let selectedTaxPeriod = _.split(element.Option, " ");
          // if (selectedTaxPeriod[1] == "Q2" || selectedTaxPeriod[1] == "Q4") {
          let obj = {};
          obj.Id = element.Id;
          obj.Option = element.Option;
          dpTaxPeriodData.push(obj);
          // }
        });
      }
      self.dropdowns.TaxPeriod.dataSource = dpTaxPeriodData;

      //Filling the Drop down options for the Grid DropDown Columns
      // this.toolbarDropDowns.TaxPeriod= this.dropdowns.TaxPeriod.dataSource;
      // let options = '<option value="1">One</option>';
      // $('#dropdownPeriodFMVStatement').empty();
      // let options ='';
      // if(self.dropdowns.TaxPeriod.dataSource.length > 0){
      //   for (let index = 0; index < self.dropdowns.TaxPeriod.dataSource.length; index++) {
      //     const optionvalue = self.dropdowns.TaxPeriod.dataSource[index];
      //     //select the recent value
      //     if(self.dropdowns.TaxPeriod.dataSource.length - index == 1){
      //       options = options +  '<option value="'+ optionvalue.Option +'" selected >'+ optionvalue.Option +'</option>';
      //     }else{
      //       options = options +  '<option value="'+ optionvalue.Option +'">'+ optionvalue.Option +'</option>';
      //     }
      //   }
      //   $('#dropdownPeriodFMVStatement').append(options);
      if (self.dropdowns.TaxPeriod.dataSource.length > 0) {
        self.dropdowns.TaxPeriod.dataSource = _.orderBy(
          self.dropdowns.TaxPeriod.dataSource,
          ["Option"],
          ["asc"]
        );
      }
      $("#dropdownPeriodFMVStatement").kendoDropDownList({
        dataSource: self.dropdowns.TaxPeriod.dataSource,
        dataTextField: "Option",
        dataValueField: "Option"
      });
      if (self.dropdowns.TaxPeriod.dataSource.length > 0) {
        // get a reference to the dropdown list and assign the latest value
        let dropdownlist = $("#dropdownPeriodFMVStatement").data(
          "kendoDropDownList"
        );
        dropdownlist.select(self.dropdowns.TaxPeriod.dataSource.length - 1);

        self.PeriodChangedEventHandler();
      } else {
        //   self.getDefaultPeriodFMVStatementReportData();
        //display the empty grid if the Period dropdown is not having the proper values
        self.FMVStatementReportInfoData = [];
      }
      // });
    },

    getCombinedFMVStatementReportData: function() {
      const self = this;
      // self._getItems(BaseModelFMVStatementReport).then( (response) => {
      //   console.log('allocations ', response)
      //   self.FMVStatementReportData = response;
      //   self.getInputControls();
      // });
      self.FMVStatementReportData = this.withFilter(
        BaseModelFMVStatementReport.list
      );
      // self.getInputControls();
      self.PeriodChangedEventHandler();
    },

    PeriodChangedEventHandler(e) {
      if (e != null && e != undefined) {
        e.preventDefault();
      }
      let self = this;
      var selectedPeriod = $("#dropdownPeriodFMVStatement").val();
      if (selectedPeriod != null && selectedPeriod != undefined) {
        self.FMVStatementReportInfoData = [];
        let IVTaxYearQuarterFilteredData = self.FMVStatementReportData.filter(
          item => {
            return item.TaxYearQuarter == selectedPeriod;
          }
        );
        self.FMVStatementReportInfoData = IVTaxYearQuarterFilteredData;
      }
    },
    refreshGrid: function() {
      // console.log("refresh grid allocation");
      this.getCombinedFMVStatementReportData();
      // $("#FMVSEntryGrid").data().kendoGrid.dataSource.read();
      // alert("Data Refreshed!");
    },
    toolbarOnClick(e) {
      e.preventDefault();
      switch (e.id) {
        case "btnDownload":
          let self = this;
          let selectedRowCount = 0;
          let grid = $("#FMVSEntryGrid").data("kendoGrid");
          let zipFilename = "Documents.zip";
          let urls = [];
          grid.select().each(function() {
            selectedRowCount++;
            urls.push(grid.dataItem(this).DownloadLink);
          });
          if (selectedRowCount > 0) {
            //let blobResponses=[];
            self
              ._ConfirmationPopup(
                `Are You Sure To Download ${selectedRowCount} Files ? This Might Take Some Time!`,
                "default"
              )
              .then(response => {
                if (response.value) {
                  self._downloadFilesZip(urls, zipFilename);
                }
              });
          } else {
            self._AlertPopup("Please select atleast one row", "info");
          }
          break;
        case "btnIndividual":
          this.$router.push("/valuation/fmvs/Individual");
          break;
        case "btnBulk":
          this.$router.push("/valuation/fmvs/BulkProcessing");
          break;
        case "btnIndividualByTaxId":
          this.$router.push("/valuation/fmvs/IndividualByTaxId");
          break;
        case "btnBulkByTaxId":
          this.$router.push("/valuation/fmvs/BulkProcessingTaxId");
          break;          
      }
      this._baseToolBarEvents("FMVSEntryGrid", ...arguments);
    },
    // filterGrid(e) {
    //     let self = this;

    //     let filteredData = this._filterGrid(
    //         this.FootnoteMasterData,
    //         this.search.SearchData
    //     );

    //     //Filter by a column
    //     $("#FMVSEntryGrid")
    //         .data("kendoGrid")
    //         .dataSource.data(filteredData);
    // },
    filterGrid: function() {
      let self = this;
      // this.ProgramInfoFormJSON = $("#programGrid").data().kendoGrid.dataSource.view()
      // var displayedData = $("#programGrid").data().kendoGrid.dataSource.view()
      //Then stringify it as follows:
      // var displayedDataAsJSON = JSON.stringify(displayedData);
      //alert(displayedDataAsJSON );
      var currentMasterdata = this.FMVStatementReportMasterData;

      let filteredData = this._filterGrid(
        this.FMVStatementReportMasterData,
        this.search.SearchData
      );
      //Filter by a column
      // let filteredData=this._filterGridbyColumn(parentGridData,"StartDate",this.searchData);
      //this.parentdata = filteredData;
      $("#FMVSEntryGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      this.UpdateFMVStatementReportMasterData(true, currentMasterdata);
    },

    UpdateFMVStatementReportMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.FMVStatementReportMasterData = filterMasterData;
      } else {
        this.FMVStatementReportMasterData = JSON.parse(
          JSON.stringify(
            $("#FMVSEntryGrid")
              .data()
              .kendoGrid.dataSource.data()
          )
        );
      }
    },
    statementDownload(e) {
      e.preventDefault();
      var gview = window.$("#FMVSEntryGrid").data("kendoGrid");
      var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      if (dataItem.Status == "Completed") {
        if (dataItem.DownloadLink == "") {
          this._AlertPopup("File not found", "info");
        } else {
          this._downloadFile(dataItem.DownloadLink);
        }
      } else {
        this._AlertPopup(
          "Report is not yet generated. Please try again once it is completed!",
          "info"
        );
      }
    }
  }
};
</script>

<style>
</style>
